import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { abnLocaleTranslationsUrl, abnVariationQuery } from './paths';
import type { AbnSuccessResponse, AbnVariationRef } from './types';

export async function upsertAbnVariationTranslations(ref: AbnVariationRef, locale: string, translationsMap: unknown) {
  /* eslint-disable camelcase */
  const body = {
    ...abnVariationQuery(ref),
    translations_map: translationsMap,
  };
  /* eslint-enable camelcase */

  const response = await api.executePutRequest<ObjectResponse<AbnSuccessResponse>>(
    abnLocaleTranslationsUrl(ref, locale),
    body
  );

  return response.data;
}
